module.exports = __webpack_public_path__ + "static/media/close.0f6bae9c.svg";